import { render, staticRenderFns } from "./budgetStatus.vue?vue&type=template&id=e8ffb426&"
import script from "./budgetStatus.vue?vue&type=script&lang=ts&"
export * from "./budgetStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports